"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMetadataTelemetryInitializer = void 0;
/**
 * Creates an initializer for adding metadata to dependency telemetry events.
 *
 * @param ai - The Application Insights client instance to attach the dependency initializer to
 * @returns A function that can be called to update the metadata
 *
 * @example
 * ```typescript
 * const ai = new ApplicationInsights();
 * const updateMetadata = createMetadataTelemetryInitializer(ai);
 *
 * // Later, update metadata
 * updateMetadata({ userId: '123', environment: 'prod' });
 * ```
 */
const createMetadataTelemetryInitializer = ai => {
  // Ensure __NEXT_DATA__ exists before accessing
  const page = typeof window !== 'undefined' ? window.__NEXT_DATA__?.page : undefined;
  const {
    referrer
  } = window.document;
  const currentMetadata = {}; // initial metadata

  ai.addTelemetryInitializer(envelope => {
    if (envelope.data) {
      const {
        properties,
        ...restData
      } = envelope.data ?? {}; //
      // eslint-disable-next-line no-param-reassign -- we need to modify the envelope
      envelope.data = {
        ...restData,
        ...properties,
        ...currentMetadata,
        ...(typeof page === 'string' ? {
          nextInternalUrl: page
        } : {}),
        ...(referrer && referrer.length > 0 ? {
          referer: referrer
        } : {})
      };
    }
    return true;
  });

  // Return function to update metadata
  return newMetadata => {
    Object.assign(currentMetadata, newMetadata);
  };
};
exports.createMetadataTelemetryInitializer = createMetadataTelemetryInitializer;
//# sourceMappingURL=createMetadataTelemetryInitializer.js.map